import React from 'react';
import { IInputCheckboxProps } from './interface';
import styles from './InputCheckbox.module.scss';
import classNames from 'classnames';

const InputCheckbox: React.FC<IInputCheckboxProps> = (props: IInputCheckboxProps) => {
    const { isChecked, onChange, children, id, extraClasses } = props;

    return (
        <div className={classNames(styles.inputCheckbox, extraClasses)}>
            <input type="checkbox" id={id} checked={isChecked} onChange={onChange} />
            <label htmlFor={id} className={styles.labelCheckbox}>
                {children}
            </label>
        </div>
    );
};

export default InputCheckbox;
